import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  agreed: {
    color: theme.palette.success.light,
  },
  notAgreed: {
    color: theme.palette.error.light,
  },
  noDecision: {
    color: theme.palette.badges.orange,
  },
}));

export default useStyles;
